(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ymm-search-product"] && !Shopify.designMode) return;
  try {
    
(async function() {
  'use strict';

  const sectionEl = document.getElementById('ymm-search-product-section');
  if (!sectionEl) return;
  const disclosureEl = document.getElementById('ymm-search-product-disclosure');
  const mobileMedia = window.matchMedia ? window.matchMedia('(max-width: 900px)') : null;
  let isMobileView = mobileMedia ? mobileMedia.matches : false;

  function syncDisclosureState(force) {
    if (!disclosureEl || !mobileMedia) return;
    const mobileNow = mobileMedia.matches;
    const shouldSync = force || mobileNow !== isMobileView;

    if (!shouldSync) return;

    isMobileView = mobileNow;

    if (mobileNow) {
      disclosureEl.removeAttribute('open');
      return;
    }
    disclosureEl.setAttribute('open', '');
  }

  function getSaved() {
    try { return JSON.parse(localStorage.getItem('ymm') || '{}'); } catch(e) { return {}; }
  }

  const saved = getSaved();
  if (saved.make && saved.model) {
    sectionEl.style.display = 'none';
    return;
  }

  sectionEl.style.display = 'block';
  syncDisclosureState(true);

  const utils = window['YMM_DATA_product_utils'];
  if (!utils) { console.warn('YMM: shared utils not loaded'); return; }

  const form      = document.getElementById('ymm-form-product');
  if (!form) return;
  const makeS     = document.getElementById('ymm-make-product');
  const modelS    = document.getElementById('ymm-model-product');
  const seriesS   = document.getElementById('ymm-series-product');
  const variantS  = document.getElementById('ymm-variant-product');
  const submitBtn = form.querySelector('.btn-search-product');
  const resetBtn  = document.getElementById('ymm-reset-product');

  function updateButtons() {
    submitBtn.disabled = !makeS.value || !modelS.value;
    const any = !!(makeS.value || modelS.value || seriesS.value || variantS.value);
    resetBtn.disabled = !any;
  }

  try {
    const db = await utils.loadVehicleDB();
    window.YMM_DATA_PRODUCT = db;

    makeS.innerHTML = '<option value="">Select Make</option>';
    makeS.disabled  = false;

    const makes = Object.keys(db).sort();
    makes.forEach(m => makeS.insertAdjacentHTML('beforeend', `<option value="${m}">${m}</option>`));

    updateButtons();

    makeS.addEventListener('change', function() {
      utils.populateModels(db, makeS, modelS, seriesS, variantS);
      updateButtons();
    });
    modelS.addEventListener('change', function() {
      utils.populateSeries(db, makeS, modelS, seriesS, variantS);
      updateButtons();
    });
    seriesS.addEventListener('change', function() {
      utils.populateVariants(db, makeS, modelS, seriesS, variantS);
      updateButtons();
    });
    variantS.addEventListener('change', updateButtons);

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      const sel = {
        make:    makeS.value,
        model:   modelS.value,
        series:  seriesS.value,
        variant: variantS.value || ''
      };
      localStorage.setItem('ymm', JSON.stringify(sel));
      window.location.reload();
    });

    resetBtn.addEventListener('click', function() {
      makeS.value        = '';
      modelS.innerHTML   = '<option value="">Select Model</option>';
      seriesS.innerHTML  = '<option value="">Year / Generation (optional)</option>';
      variantS.innerHTML = '<option value="">Variant (optional)</option>';
      modelS.disabled = seriesS.disabled = variantS.disabled = true;
      localStorage.removeItem('ymm');
      submitBtn.disabled = true;
      updateButtons();
    });

  } catch (err) {
    console.error('YMM Product load error:', err);
    makeS.innerHTML = '<option value="">Error loading – please refresh</option>';
  }

  window.addEventListener('storage', function(e) {
    if (e.key === 'ymm') {
      const v = getSaved();
      if (v.make && v.model) sectionEl.style.display = 'none';
    }
  });

  window.addEventListener('pageshow', function(e) {
    if (e.persisted) {
      const v = getSaved();
      sectionEl.style.display = (v.make && v.model) ? 'none' : 'block';
      if (!(v.make && v.model)) syncDisclosureState(true);
    }
  });

  window.addEventListener('resize', syncDisclosureState);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ymm-search"] && !Shopify.designMode) return;
  try {
    
(async function() {
  'use strict';

  const utils = window['YMM_DATA_utils'];
  if (!utils) { console.warn('YMM: shared utils not loaded'); return; }

  const form      = document.getElementById('ymm-form');
  if (!form) return;
  const makeS     = document.getElementById('ymm-make');
  const modelS    = document.getElementById('ymm-model');
  const seriesS   = document.getElementById('ymm-series');
  const variantS  = document.getElementById('ymm-variant');
  const submitBtn = form.querySelector('.btn-search');
  const resetBtn  = document.getElementById('ymm-reset');

  function updateButtons() {
    submitBtn.disabled = !makeS.value || !modelS.value;
    const any = !!(makeS.value || modelS.value || seriesS.value || variantS.value);
    resetBtn.disabled = !any;
  }

  function attachEvents() {
    makeS.addEventListener('change', function() {
      utils.populateModels(window.YMM_DATA, makeS, modelS, seriesS, variantS);
      updateButtons();
    });
    modelS.addEventListener('change', function() {
      utils.populateSeries(window.YMM_DATA, makeS, modelS, seriesS, variantS);
      updateButtons();
    });
    seriesS.addEventListener('change', function() {
      utils.populateVariants(window.YMM_DATA, makeS, modelS, seriesS, variantS);
      updateButtons();
    });
    variantS.addEventListener('change', updateButtons);

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      const sel = {
        make:    makeS.value,
        model:   modelS.value,
        series:  seriesS.value,
        variant: variantS.value || ''
      };
      localStorage.setItem('ymm', JSON.stringify(sel));

      const UNIVERSAL = 'Universal';
      let q = `?filter.p.m.custom.ymm_make=${encodeURIComponent(sel.make)}`
            + `&filter.p.m.custom.ymm_make=${UNIVERSAL}`
            + `&filter.p.m.custom.ymm_model=${encodeURIComponent(sel.model)}`
            + `&filter.p.m.custom.ymm_model=${UNIVERSAL}`;
      if (sel.series) q += `&filter.p.m.custom.series_ymm=${encodeURIComponent(sel.series)}`
                         + `&filter.p.m.custom.series_ymm=${UNIVERSAL}`;
      if (sel.variant) q += `&filter.p.m.custom.ymm_variant=${encodeURIComponent(sel.variant)}`
                          + `&filter.p.m.custom.ymm_variant=${UNIVERSAL}`;
      window.location.href = `/collections/all${q}`;
    });

    resetBtn.addEventListener('click', function() {
      makeS.value        = '';
      modelS.innerHTML   = '<option value="">Select Model</option>';
      seriesS.innerHTML  = '<option value="">Year / Generation (optional)</option>';
      variantS.innerHTML = '<option value="">Variant (optional)</option>';
      modelS.disabled = seriesS.disabled = variantS.disabled = true;
      localStorage.removeItem('ymm');
      submitBtn.disabled = true;
      updateButtons();
    });
  }

  try {
    const db = await utils.loadVehicleDB();
    window.YMM_DATA = db;

    makeS.innerHTML = '<option value="">Select Make</option>';
    makeS.disabled  = false;

    const makes = Object.keys(db).sort();
    makes.forEach(m => makeS.insertAdjacentHTML('beforeend', `<option value="${m}">${m}</option>`));

    // Restore previous selection from localStorage
    const saved = JSON.parse(localStorage.getItem('ymm') || '{}');
    if (saved.make)   { makeS.value   = saved.make;   utils.populateModels(db, makeS, modelS, seriesS, variantS); }
    if (saved.model)  { modelS.value  = saved.model;  utils.populateSeries(db, makeS, modelS, seriesS, variantS); }
    if (saved.series) { seriesS.value = saved.series; utils.populateVariants(db, makeS, modelS, seriesS, variantS); }
    if (saved.variant) {
      const has = Array.from(variantS.options).some(o => o.value === saved.variant);
      if (has) variantS.value = saved.variant;
    }
    updateButtons();
    attachEvents();

    // === Dynamic card titles for special products on collection pages ===
    var _ymmCardTitles = {
      'we-can-make-a-leather-trim-kit-for-your-vehicle': '{vehicle} Leather Trim Kit'
    };
    var cardLabelParts = [];
    if (saved.make)    cardLabelParts.push(saved.make);
    if (saved.model)   cardLabelParts.push(saved.model);
    if (saved.variant) cardLabelParts.push(saved.variant);
    var cardVehicleLabel = cardLabelParts.join(' ');
    if (cardVehicleLabel) {
      function applyCollectionCardTitles() {
        Object.keys(_ymmCardTitles).forEach(function(handle) {
          var newTitle = _ymmCardTitles[handle].replace('{vehicle}', cardVehicleLabel);
          document.querySelectorAll('.card__heading .full-unstyled-link').forEach(function(el) {
            var href = el.getAttribute('href') || '';
            if (href.indexOf('/products/' + handle) !== -1 && !el.dataset.ymmOriginal) {
              el.dataset.ymmOriginal = el.textContent.trim();
              el.textContent = newTitle;
            }
          });
        });
      }
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', applyCollectionCardTitles);
      } else {
        applyCollectionCardTitles();
      }
    }

  } catch (err) {
    console.error('YMM Search load error:', err);
    makeS.innerHTML = '<option value="">Error loading – please refresh</option>';
  }
})();

  } catch(e) { console.error(e); }
})();
})();
